import { signal } from '@preact/signals';
import { ChatHeader } from '../ChatHeader';
import type { ComponentShowcase } from '../registry';

const mockModels = signal([
  { id: 'claude-sonnet', name: 'Claude Sonnet', provider: 'Anthropic' },
  { id: 'gpt-4o', name: 'GPT-4o', provider: 'OpenAI' },
]);
const mockSelected = signal('claude-sonnet');

export const showcase: ComponentShowcase = {
  name: 'ChatHeader',
  category: '💬 Chat',
  description: 'Header desktop do Chat Hub estilo ChatGPT — mostra nome do app, modelo selecionado, perfil e nova conversa.',
  usedIn: ['ChatHubPage'],
  example: () => (
    <div style={{ border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, overflow: 'hidden' }}>
      <ChatHeader
        models={mockModels}
        selectedModel={mockSelected}
        showNewChat={true}
        onProfile={() => alert('Perfil')}
        onNewChat={() => alert('Nova conversa')}
      />
    </div>
  ),
};
